import React, { useState } from 'react';
import Select from "react-select";

export default function SelectMulti(props: any) {
    const { className } = props || '';
    const [selectedOptions, setSelectedOptions] = useState<any>([])

    return (
        <Select
            isMulti
            cacheOptions
            defaultOptions
            value={selectedOptions}
            onChange={(v: any) => {
                setSelectedOptions(v); props?.onInput?.(v)
            }}
            className={` border-gray-100 shadow-sm focus:outline-none ${className ?? ''}`}
            {...props}
        />
    )
}
